<script>
  import { onMount } from "svelte";

  let { http, toastr, goTo, id } = $props();

  let czlonek = $state(null);

  onMount(() => {
    http.get("/api/czlonek.php?id=" + id).then(
      (response) => {
        czlonek = response.data.records[0];
      },
      () => {
        toastr.error("Błąd połączenia");
      },
    );
  });

  function save(event) {
    event.preventDefault();
    http.put("/api/czlonek.php", czlonek).then(
      (response) => {
        if (response.data.status == 200) {
          http.post("/api/workspace.php?id=" + id).then(
            (wsResponse) => {
              if (wsResponse.data.status == 200) {
                toastr.info("Utworzono konto Google Workspace");
              } else {
                toastr.warning(
                  "Zapisano dane, ale nie udało się utworzyć konta Workspace",
                );
              }
              goTo("member-detail", { id });
            },
            () => {
              toastr.warning(
                "Zapisano dane, ale nie udało się utworzyć konta Workspace",
              );
              goTo("member-detail", { id });
            },
          );
        } else {
          toastr.error("Błąd: " + response.data.message);
        }
      },
      () => {
        toastr.error("Błąd połączenia");
      },
    );
  }

  function cancel() {
    goTo("member-detail", { id });
  }
</script>

{#if czlonek}
<h3>Utwórz konto MJN: {czlonek.imie} {czlonek.nazwisko}</h3>

<form class="form form-inline" onsubmit={save} role="form">
<table class="table table-condensed table-hover table-striped">
    <tbody>
      <tr>
        <td>Imię:</td>
        <td><input type="text" class="form-control input-sm" bind:value={czlonek.imie} size="30" required></td>
      </tr>
      <tr>
        <td>Nazwisko:</td>
        <td><input type="text" class="form-control input-sm" bind:value={czlonek.nazwisko} size="30" required></td>
      </tr>
      <tr>
        <td>Adres e-mail MJN:</td>
        <td><input type="email" class="form-control input-sm" placeholder="imie.nazwisko@miastojestnasze.org" bind:value={czlonek.email_mjn} size="50" required></td>
      </tr>
      <tr>
        <td>Adres e-mail (prywatny):</td>
        <td><input type="email" class="form-control input-sm" bind:value={czlonek.email} size="50"></td>
      </tr>
      <tr>
        <td>Numer telefonu:</td>
        <td><input type="text" class="form-control input-sm" bind:value={czlonek.nrtel} size="20"></td>
      </tr>
    </tbody>
</table>

<button class="btn btn-info" type="submit">Utwórz konto</button>
<button class="btn btn-default" type="button" onclick={cancel}>Anuluj</button>
</form>
{/if}
